module.exports = __webpack_public_path__ + "img/impact.9be5a1be.svg";